// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"cad01f45","235":"2e69aa4f","255":"8520080a","311":"9fcb1a31","409":"809f69be","424":"5f2395d5","533":"5187335d","534":"eb7a8948","617":"cf0e1a50","633":"65e5b95b","769":"eb07ea8b","972":"07a0241e"}[chunkId] + ".chunk.js";
};